import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"

import {TextArea as TextAreaUi} from "@irati/ui/src/FormItem"
import widths from "../widths"

// Matching textarea border color to the input border color (/web/ui/src/TextInput/style.css)
const StyledTextArea = styled(({wide, ...rest}) => <TextAreaUi {...rest} />)`
  ${minWidthMedia.tablet`
    max-width: ${({wide}) => (wide ? widths.medium : widths.small)};
  `}
  textarea {
    border: 1px solid grey;
  }
`

const TextArea = ({wide, ...props}) => <StyledTextArea wide={wide} {...props} />


TextArea.propTypes = {
  wide: PropTypes.bool
}
TextArea.defaultProps = {
  wide: false
}
export default TextArea
